export default {
	editor_background_color: 'Hintergrundfarbe',
	editor_default_font_removed: 'Gespeicherte Standard-Schriftart entfernt',
	editor_default_font_saved: 'Schriftart und -größe als Standard gespeichert',
	editor_remove_default_font: 'Gespeicherte Standard-Schriftart entfernen',
	editor_save_default_font: 'Aktuelle Schriftart und -größe als Standard speichern',
	editor_text_color: 'Textfarbe',
	mail_attachment_to_document_already_converted: 'Anhang ist bereits in der Dokumentenablage',
	mail_attachment_to_document_cancel: 'Abbrechen',
	mail_attachment_to_document_failed: 'Anlegen fehlgeschlagen',
	mail_attachment_to_document_no_postboxes: 'Keine Ablagen verfügbar',
	mail_attachment_to_document_postbox_label: 'Ablage',
	mail_attachment_to_document_submit: 'Dokument anlegen',
	mail_attachment_to_document_success: 'Dokument angelegt',
	mail_attachment_to_document_title: 'Anhang in Dokumentenablage überführen',
	mail_bcc: 'BCC',
	mail_cc: 'CC',
	mail_compose_attach_files: 'Anhänge',
	mail_compose_auto_drafts_hidden_hint: '{count} ältere automatische Speicherungen ausgeblendet',
	mail_compose_automatic_saved_drafts: 'automatische Speicherungen',
	mail_compose_bcc: 'BCC',
	mail_compose_cc: 'CC',
	mail_compose_cc_bcc: 'CC/BCC',
	mail_compose_delete_attachment_dialog_message_prefix: 'Möchten Sie wirklich den Anhang mit dem Namen',
	mail_compose_delete_attachment_dialog_message_suffix: 'löschen?',
	mail_compose_delete_attachment_dialog_title: 'Anhang löschen',
	mail_compose_delete_draft: 'Entwurf löschen',
	mail_compose_delete_draft_dialog_message_prefix: 'Möchten Sie wirklich den Entwurf mit dem Namen',
	mail_compose_delete_draft_dialog_message_suffix: 'löschen?',
	mail_compose_delete_draft_dialog_title: 'Entwurf löschen',
	mail_compose_delete_draft_notify_message_prefix: 'Der Entwurf mit dem Namen',
	mail_compose_delete_draft_notify_message_suffix: 'wurde gelöscht',
	mail_compose_delete_template: 'Vorlage löschen',
	mail_compose_delete_template_dialog_message_prefix: 'Möchten Sie wirklich die Vorlage mit dem Namen',
	mail_compose_delete_template_dialog_message_suffix: 'löschen?',
	mail_compose_delete_template_dialog_title: 'Vorlage löschen',
	mail_compose_delete_template_notify_message_prefix: 'Die Vorlage mit dem Namen',
	mail_compose_delete_template_notify_message_suffix: 'wurde gelöscht',
	mail_compose_dialog_camera: 'Kamera',
	mail_compose_dialog_mediathek: 'Mediathek',
	mail_compose_dialog_select_files: 'Dateien auswählen',
	mail_compose_dialog_selected_files: 'Ausgewählt',
	mail_compose_dialog_upload_files: 'Dateien hochladen',
	mail_compose_dialog_uploading: 'Lade hoch ....',
	mail_compose_draft_button: 'Entwürfe',
	mail_compose_draft_button_delete: 'Entwurf löschen',
	mail_compose_draft_button_save: 'Entwurf speichern',
	mail_compose_drafts_empty: 'Keine Entwürfe vorhanden',
	mail_compose_drop_image_as_attachment: 'Als Anhang',
	mail_compose_drop_image_dialog_message: 'Wie möchten Sie das Bild einfügen?',
	mail_compose_drop_image_dialog_title: 'Bild einfügen',
	mail_compose_drop_image_inline: 'Inline einfügen',
	mail_compose_editor_drop_hint_message: 'Bild oder Datei hier loslassen, um den Upload zu starten.',
	mail_compose_editor_drop_hint_title: 'Zum Hochladen in den Editor ziehen',
	mail_compose_forward_date: 'Datum',
	mail_compose_forward_header: 'Weitergeleitete Nachricht',
	mail_compose_forward_sender: 'Absender',
	mail_compose_forward_subject: 'Betreff',
	mail_compose_global_drafts: 'globale Entwürfe',
	mail_compose_global_templates: 'globale Vorlagen',
	mail_compose_ido_persist_failed:
		'Die E-Mail wurde gesendet, aber die Akten-Verknüpfung konnte nicht gespeichert werden.',
	mail_compose_inline_image_hint_many: '{count} Inline-Bilder werden mitgesendet',
	mail_compose_inline_image_hint_one: '{count} Inline-Bild wird mitgesendet',
	mail_compose_managed_signature: 'Signatur',
	mail_compose_open_video_link: 'Video öffnen',
	mail_compose_own_drafts: 'eigene Entwürfe',
	mail_compose_own_templates: 'eigene Vorlagen',
	mail_compose_provide_template_name_message: 'Bitte geben Sie den Namen der Vorlage ein',
	mail_compose_provide_template_name_title: 'Vorlage speichern',
	mail_compose_recipient_search_failed: 'Suche fehlgeschlagen',
	mail_compose_recipient_search_minimum_input: 'Mindestens 3 Zeichen eingeben',
	mail_compose_recipient_search_no_matches: 'Keine Treffer',
	mail_compose_recipient_search_running: 'Suche läuft…',
	mail_compose_save_draft: 'Entwurf speichern',
	mail_compose_save_draft_notify_message_prefix: 'Der Entwurf mit dem Namen',
	mail_compose_save_draft_notify_message_suffix: 'wurde gespeichert',
	mail_compose_save_template: 'Vorlage speichern',
	mail_compose_save_template_new_btn: 'Als neue Vorlage speichern',
	mail_compose_save_template_notify_message_prefix: 'Die Vorlage mit dem Namen',
	mail_compose_save_template_notify_message_suffix: 'wurde gespeichert',
	mail_compose_save_template_overwrite_btn: 'Überschreiben',
	mail_compose_save_template_overwrite_message:
		'Möchten Sie die bestehende Vorlage „{name}“ überschreiben oder als neue Vorlage speichern?',
	mail_compose_save_template_overwrite_title: 'Vorlage speichern',
	mail_compose_send: 'Senden',
	mail_compose_send_later_dialog_cancel: 'Abbrechen',
	mail_compose_send_later_dialog_send_later: 'Später senden',
	mail_compose_send_later_dialog_send_later_title: 'Mail später senden',
	mail_compose_send_unconfirmed:
		'Der E-Mail-Versand konnte nicht bestätigt werden. Bitte prüfen Sie den Gesendet-Ordner, bevor Sie erneut senden.',
	mail_compose_sender: 'Absender',
	mail_compose_signature_preview_empty: 'Keine Signatur verfügbar',
	mail_compose_signature_preview_title: 'Signatur-Vorschau',
	mail_compose_signature_preview_tooltip: 'Signatur-Vorschau',
	mail_compose_standard_template_hint: 'Standardvorlage für {account}',
	mail_compose_subject: 'Betreff',
	mail_compose_template_button: 'Vorlagen',
	mail_compose_template_button_delete: 'Vorlage löschen',
	mail_compose_template_button_save: 'Vorlage speichern',
	mail_compose_templates_empty: 'Keine Vorlagen vorhanden',
	mail_compose_to: 'An',
	mail_compose_upload_failed_prefix: 'Upload fehlgeschlagen: ',
	mail_contact_picture_action_label: 'Kontaktbild setzen',
	mail_contact_picture_cancel_label: 'Abbrechen',
	mail_contact_picture_current_alt: 'Aktuelles Kontaktbild',
	mail_contact_picture_dialog_title: 'Kontaktbild aus E-Mail setzen',
	mail_contact_picture_drop_hint: 'oder Bilddatei hier ablegen',
	mail_contact_picture_google_search_label: 'Google-Bildersuche',
	mail_contact_picture_invalid_file_error: 'Bitte wählen Sie eine Bilddatei aus.',
	mail_contact_picture_loading_preview: 'Vorschau wird geladen...',
	mail_contact_picture_no_images_message: 'Diese E-Mail enthält keine verwendbaren Bildanhänge.',
	mail_contact_picture_preview_alt: 'Vorschau des ausgewählten Kontaktbildes',
	mail_contact_picture_preview_empty: 'Wählen Sie einen Bildanhang oder eine Bilddatei aus.',
	mail_contact_picture_preview_label: 'Vorschau',
	mail_contact_picture_preview_load_error: 'Die Bildvorschau konnte nicht geladen werden.',
	mail_contact_picture_replace_label: 'Anderes Bild wählen',
	mail_contact_picture_save_error: 'Kontaktbild konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
	mail_contact_picture_save_label: 'Kontaktbild speichern',
	mail_contact_picture_save_success: 'Kontaktbild wurde gespeichert.',
	mail_contact_picture_source_email_label: 'Bilder aus dieser E-Mail',
	mail_contact_picture_source_upload_label: 'Bild auswählen',
	mail_contact_picture_target_label: 'Kontakt',
	mail_copied_to_destination_account_success: 'Die E-Mail wurde erfolgreich in das Zielkonto kopiert',
	mail_date: 'Datum',
	mail_delete_dialog_confirm_cancel_label: 'Nein',
	mail_delete_dialog_confirm_message: 'Möchten Sie diese E-Mail wirklich löschen?',
	mail_delete_dialog_confirm_ok_label: 'Ja',
	mail_delete_dialog_confirm_title: 'E-Mail löschen',
	mail_extended_search_active_tooltip: 'Detailsuche aktiv: {count} Felder',
	mail_extended_search_apply_label: 'Anwenden',
	mail_extended_search_cancel_label: 'Abbrechen',
	mail_extended_search_clear_label: 'Zurücksetzen',
	mail_extended_search_contact_label: 'Kontakt',
	mail_extended_search_file_type_label: 'Dateityp',
	mail_extended_search_filename_label: 'Dateiname',
	mail_extended_search_min_length_hint: 'Mindestens 4 Zeichen eingeben.',
	mail_extended_search_no_suggestions: 'Keine Vorschläge',
	mail_extended_search_open_label: 'Detailsuche',
	mail_extended_search_subject_label: 'Betreff',
	mail_extended_search_suggestions_error: 'Vorschläge konnten nicht geladen werden.',
	mail_extended_search_text_label: 'Text',
	mail_extended_search_title: 'E-Mail-Detailsuche',
	mail_forward: 'Weiterleiten',
	mail_from: 'Von',
	mail_invitation_action_accepted: 'Zusagen',
	mail_invitation_action_declined: 'Absagen',
	mail_invitation_action_tentative: 'Mit Vorbehalt zusagen',
	mail_invitation_block_title: 'Terminbestätigung',
	mail_invitation_respond_failed: 'Die Terminantwort konnte nicht vorgemerkt werden.',
	mail_invitation_respond_queued: 'Die Terminantwort ist zum Versand vorgemerkt.',
	mail_invitation_respond_queued_link_not_stored:
		'Die Terminantwort ist zum Versand vorgemerkt. Der lokale Antwortstatus konnte nicht gespeichert werden.',
	mail_invitation_status_accepted: 'Zugesagt',
	mail_invitation_status_declined: 'Abgelehnt',
	mail_invitation_status_label: 'Ihre Antwort',
	mail_invitation_status_responded: 'Beantwortet',
	mail_invitation_status_tentative: 'Mit Vorbehalt',
	mail_legacy_back_to_default: 'Zur normalen Ansicht zurück',
	mail_legacy_download_source: 'Quelltext herunterladen',
	mail_legacy_load_failed: 'Die Ansicht konnte nicht geladen werden.',
	mail_legacy_loading_source: 'Quelltext wird geladen...',
	mail_legacy_loading_unprocessed: 'Nicht preprocessed Ansicht wird geladen...',
	mail_legacy_show_source: 'Quelltext anzeigen',
	mail_legacy_show_unprocessed: 'Nachricht nicht lesbar?',
	mail_legacy_source_badge: 'Quelltext',
	mail_legacy_source_unavailable: 'Der Quelltext dieser E-Mail ist nicht verfügbar.',
	mail_legacy_unprocessed_badge: 'Original',
	mail_legacy_unprocessed_unavailable: 'Die Original Ansicht ist für diese E-Mail nicht verfügbar.',
	mail_print: 'Drucken',
	mail_print_attachments: 'Anhänge',
	mail_receiver_groups_add_members_button: 'Adressen hinzufügen',
	mail_receiver_groups_add_members_failed: 'Adressen konnten nicht hinzugefügt werden.',
	mail_receiver_groups_add_members_hint:
		'E-Mail-Adresse suchen oder mehrere Adressen mit Semikolon, Komma, Leerzeichen oder Zeilenumbruch einfügen.',
	mail_receiver_groups_add_members_label: 'E-Mail-Adresse suchen',
	mail_receiver_groups_add_members_success: 'Adressen wurden hinzugefügt.',
	mail_receiver_groups_caption: 'Empfängergruppen für die Mail-Erstellung verwalten.',
	mail_receiver_groups_create_button: 'Gruppe erstellen',
	mail_receiver_groups_create_failed: 'Empfängergruppe konnte nicht erstellt werden.',
	mail_receiver_groups_create_name_label: 'Gruppenname',
	mail_receiver_groups_create_success: 'Empfängergruppe wurde erstellt.',
	mail_receiver_groups_delete_confirm_accept: 'Löschen',
	mail_receiver_groups_delete_confirm_message: 'Möchten Sie diese Empfängergruppe wirklich löschen?',
	mail_receiver_groups_delete_confirm_reject: 'Abbrechen',
	mail_receiver_groups_delete_confirm_title: 'Empfängergruppe löschen',
	mail_receiver_groups_delete_failed: 'Empfängergruppe konnte nicht gelöscht werden.',
	mail_receiver_groups_delete_group: 'Empfängergruppe löschen',
	mail_receiver_groups_delete_success: 'Empfängergruppe wurde gelöscht.',
	mail_receiver_groups_delivery_hint:
		'Beim Senden wird die ausgewählte Gruppe automatisch in ihre E-Mail-Adressen aufgelöst.',
	mail_receiver_groups_empty: 'Keine Empfängergruppen vorhanden.',
	mail_receiver_groups_list_label: 'Empfängergruppen',
	mail_receiver_groups_load_failed: 'Empfängergruppen konnten nicht geladen werden.',
	mail_receiver_groups_loading: 'Empfängergruppen werden geladen...',
	mail_receiver_groups_member_count: '{count} Adressen',
	mail_receiver_groups_members_empty: 'Diese Empfängergruppe enthält noch keine Adressen.',
	mail_receiver_groups_members_failed: 'Mitglieder konnten nicht geladen werden.',
	mail_receiver_groups_members_label: 'Mitglieder',
	mail_receiver_groups_open_button: 'Gruppen',
	mail_receiver_groups_open_tooltip: 'Empfängergruppen verwalten',
	mail_receiver_groups_remove_member: 'Adresse entfernen',
	mail_receiver_groups_remove_member_failed: 'Adresse konnte nicht entfernt werden.',
	mail_receiver_groups_remove_member_success: 'Adresse wurde entfernt.',
	mail_receiver_groups_select_hint: 'Wählen Sie eine Empfängergruppe aus, um die Mitglieder zu bearbeiten.',
	mail_receiver_groups_title: 'Empfängergruppen',
	mail_receiver_groups_validation_group_name_required: 'Bitte geben Sie einen Gruppennamen ein.',
	mail_receiver_groups_validation_members_required: 'Bitte geben Sie mindestens eine gültige E-Mail-Adresse ein.',
	mail_reply: 'Antworten',
	mail_reply_no_access: 'Keine Berechtigung zum Anzeigen der Antwort',
	mail_reply_status_answered: 'Diese E-Mail wurde beantwortet',
	mail_replyAll: 'Allen antworten',
	mail_rules_archive_title: 'Ausgeblendete Adressen',
	mail_rules_auto_delegate_back: 'Zurück',
	mail_rules_auto_delegate_cancel: 'Abbrechen',
	mail_rules_auto_delegate_col_creator: 'Ersteller',
	mail_rules_auto_delegate_col_edit: 'Bearbeiten',
	mail_rules_auto_delegate_col_from: 'vom',
	mail_rules_auto_delegate_col_mailboxes: 'Postfächer',
	mail_rules_auto_delegate_col_name: 'Regelname',
	mail_rules_auto_delegate_col_to: 'bis zum',
	mail_rules_auto_delegate_col_users: 'Benutzer',
	mail_rules_auto_delegate_delete: 'Löschen',
	mail_rules_auto_delegate_edit: 'Bearbeiten',

	mail_rules_auto_delegate_empty: 'Keine Autodelegierungsregeln vorhanden',
	mail_rules_auto_delegate_from: 'vom',

	mail_rules_auto_delegate_hidden_info: 'Dies gilt',
	mail_rules_auto_delegate_hidden_info_suffix: 'für E-Mails von ausgeblendeten Adressen.',
	mail_rules_auto_delegate_hidden_not: 'nicht',
	mail_rules_auto_delegate_include_hidden: 'inklusive der Mails von ausgeblendeten Adressen.',
	mail_rules_auto_delegate_mailboxes_legend: 'alle E-Mails in den Postfächern',
	mail_rules_auto_delegate_name_error_blank: 'Das Feld darf nicht leer sein',
	mail_rules_auto_delegate_name_label: 'Name',
	mail_rules_auto_delegate_name_legend: 'Die Autodelegationsregeln mit dem Namen',
	mail_rules_auto_delegate_new_rule: 'Neue Regel',
	mail_rules_auto_delegate_period_legend: 'besagt, dass in dem Zeitraum',
	mail_rules_auto_delegate_save: 'Speichern',
	mail_rules_auto_delegate_save_error: 'Beim Speichern ist ein Fehler aufgetreten.',
	mail_rules_auto_delegate_status_green: 'Grün',
	mail_rules_auto_delegate_status_legend: 'Der Status der E-Mail in meinem Postfach wird dann',
	mail_rules_auto_delegate_status_red: 'Rot',
	mail_rules_auto_delegate_status_yellow: 'Gelb',
	mail_rules_auto_delegate_to: 'bis zum',
	mail_rules_auto_delegate_users_legend: 'für die Benutzer',
	mail_rules_autodelegate_title: 'Autodelegationsregel hinzufügen',
	mail_rules_blacklist_column_name: 'E-Mail-Adresse',
	mail_rules_blacklist_empty: 'Keine Adressen auf der Blacklist vorhanden',
	mail_rules_blacklist_title: 'E-Mail-Adressen auf der Blacklist',
	mail_rules_delete_rule: 'Regel löschen',
	mail_rules_dialog_confirm_cancel_label: 'Nein',
	mail_rules_dialog_confirm_message: 'Möchten Sie diese Regel wirklich löschen?',
	mail_rules_dialog_confirm_ok_label: 'Ja',
	mail_rules_dialog_confirm_title: 'Regel löschen',
	mail_rules_dialog_title: 'E-Mail Regeln',
	mail_rules_existing_auto_delegate_title: 'Bestehende Autodelegation',
	mail_rules_existing_filter_title: 'Spam markierte E-Mail-Adressen',
	mail_rules_existing_rules_title: 'Bestehende Spamregeln',
	mail_rules_filter: 'Suche...',
	mail_rules_hidden_address: 'auszuschließende Adresse',
	mail_rules_hidden_col_mailbox: 'Postfach',
	mail_rules_hidden_col_sender: 'Absender',
	mail_rules_hidden_delete: 'Regel löschen',
	mail_rules_hidden_empty: 'Keine verborgenen Adressen vorhanden',
	mail_rules_hidden_mailbox: 'Postfach',
	mail_rules_hidden_mailbox_all: 'alle meine E-Mail-Adressen',
	mail_rules_hidden_save: 'Regel speichern',
	mail_rules_hidden_title: 'Adresse ausblenden',
	mail_rules_list_delete: 'Regel löschen',
	mail_rules_list_empty: 'Keine Spamregeln vorhanden',
	mail_rules_marked_empty: 'Keine Spam markierten Adressen vorhanden',
	mail_rules_new_rule_condition: 'Spamregel',
	mail_rules_new_rule_dialog_name: 'Name der Regel',
	mail_rules_new_rule_field_body: 'Body',
	mail_rules_new_rule_field_from: 'From',
	mail_rules_new_rule_field_label: 'Feld',
	mail_rules_new_rule_field_subject: 'Subject',
	mail_rules_new_rule_field_to: 'To',
	mail_rules_new_rule_mailbox: 'Postfach',
	mail_rules_new_rule_mailbox_all: 'alle meine E-Mail-Adressen',
	mail_rules_new_rule_name: 'Regel',
	mail_rules_new_rule_operator_contains: 'ENTHÄLT',
	mail_rules_new_rule_operator_ends_with: 'ENDET MIT',
	mail_rules_new_rule_operator_equals: 'GLEICH',
	mail_rules_new_rule_operator_label: 'Operator',
	mail_rules_new_rule_operator_not_contains: 'ENTHÄLT NICHT',
	mail_rules_new_rule_operator_not_ends_with: 'ENDET NICHT MIT',
	mail_rules_new_rule_operator_not_starts_with: 'BEGINNT NICHT MIT',
	mail_rules_new_rule_operator_starts_with: 'BEGINNT MIT',
	mail_rules_new_rule_save: 'Regel speichern',
	mail_rules_new_rule_title: 'neue Spamregel definieren',
	mail_rules_page_of: "von {'{'}totalPages{'}'}",
	mail_rules_page_report: 'Anzeige Eintrag {first} - {last} von {totalRecords}',
	mail_rules_placeholder_coming_soon: 'Diese Funktion wird bald verfügbar sein',
	mail_rules_tab_auto_delegate: 'Autodelegieren',
	mail_rules_tab_blacklist: 'Blacklist',
	mail_rules_tab_hidden_addresses: 'verborgene Adressen',
	mail_rules_tab_more: 'Mehr',
	mail_rules_tab_remove_spam: 'Spammarkierung entfernen',
	mail_rules_tab_rules: 'Spamregeln',
	mail_rules_type_custom_header: 'Mit der Eingabetaste bestätigen',
	mail_send_as_new: 'Als neue Mail senden',
	mail_show_reply: 'Antwort anzeigen',
	mail_signatures_badge_default: 'Standard',
	mail_signatures_badge_global_template: 'Globale Signatur',
	mail_signatures_clear_default_popup_title: 'Standard entfernen',
	mail_signatures_col_actions: 'Aktionen',
	mail_signatures_col_default: 'Standard',
	mail_signatures_col_name: 'Name',
	mail_signatures_col_postbox: 'Postfach',
	mail_signatures_custom_field_caption: 'Platzhalter: {{{key}}}',
	mail_signatures_custom_field_placeholder: 'Wert eingeben...',
	mail_signatures_custom_fields_title: 'Eigene Felder',
	mail_signatures_custom_placeholders_caption:
		'Eigene Platzhalter für Signaturen definieren; Werte je Benutzer anpassbar.',
	mail_signatures_custom_placeholders_default_label: 'Standard',
	mail_signatures_custom_placeholders_default_value_label: 'Standardwert (optional)',
	mail_signatures_custom_placeholders_delete_confirm:
		'Platzhalter wirklich löschen? Alle User-Werte werden ebenfalls gelöscht.',
	mail_signatures_custom_placeholders_empty_caption: 'Lege mit dem Button oben einen neuen an.',
	mail_signatures_custom_placeholders_empty_title: 'Keine Custom-Platzhalter vorhanden',
	mail_signatures_custom_placeholders_key_hint:
		'Nur Kleinbuchstaben, Zahlen und _ erlaubt. Nicht änderbar nach Erstellung.',
	mail_signatures_custom_placeholders_key_label: 'Schlüssel (z.B. webseite)',
	mail_signatures_custom_placeholders_key_reserved_error: 'Dieser Schlüssel ist reserviert.',
	mail_signatures_custom_placeholders_label_label: 'Bezeichnung',
	mail_signatures_custom_placeholders_new: 'Neuer Platzhalter',
	mail_signatures_custom_placeholders_select_user: 'User auswählen',
	mail_signatures_custom_placeholders_title: 'Custom Platzhalter',
	mail_signatures_custom_placeholders_user_override_title: 'User-Werte anpassen',
	mail_signatures_delete_confirm_message: 'Möchtest du diese Signatur wirklich löschen?',
	mail_signatures_delete_confirm_title: 'Signatur löschen',
	mail_signatures_edit_signature: 'Signatur bearbeiten',
	mail_signatures_empty_caption: 'Erstelle deine erste Signatur mit dem Button oben.',
	mail_signatures_empty_title: 'Keine Signaturen',
	mail_signatures_my_signatures_caption: 'Eigene Signaturen anlegen und je Postfach als Standard festlegen.',
	mail_signatures_nav_label: 'Signaturen',
	mail_signatures_new_signature: 'Neue Signatur',
	mail_signatures_placeholders_label: 'Platzhalter einfügen:',
	mail_signatures_postbox_all: 'Alle Postfächer',
	mail_signatures_preview_button_tooltip: 'Vorschau anzeigen',
	mail_signatures_preview_placeholder_hint:
		"Platzhalter wie {'{{vorname}}'} werden beim Versenden durch die eigenen Nutzerdaten ersetzt.",
	mail_signatures_preview_title: 'Vorschau aufgelöster Platzhalter',
	mail_signatures_set_as_default: 'Als Standard für dieses Postfach setzen',
	mail_signatures_set_as_default_all_confirm_message:
		'Diese Aktion setzt die Signatur als Standard für alle Postfächer und überschreibt alle bestehenden per-Postfach-Standards. Fortfahren?',
	mail_signatures_set_as_default_all_confirm_title: 'Alle Postfächer überschreiben?',
	mail_signatures_set_as_default_all_mailboxes: 'Als Standard für alle Postfächer setzen',
	mail_signatures_set_as_default_all_resets_hint:
		'Setzt diese Signatur als Standard für alle Postfächer und entfernt alle bestehenden per-Postfach-Einstellungen.',
	mail_signatures_set_as_default_popup_title: 'Standard für',
	mail_signatures_set_as_default_tooltip: 'Als Standard festlegen',
	mail_signatures_tab_custom_placeholders: 'Platzhalter',
	mail_signatures_tab_global_templates: 'Globale Signaturen',
	mail_signatures_tab_my_signatures: 'Meine Signaturen',
	mail_signatures_tab_user_fields: 'Meine Platzhalter',
	mail_signatures_tab_user_signatures: 'Benutzer-Signaturen',
	mail_signatures_templates_caption: 'Vorlagen, die allen Benutzern zur Verfügung stehen.',
	mail_signatures_templates_col_active: 'Aktiv',
	mail_signatures_templates_col_inactive: 'Inaktiv',
	mail_signatures_templates_col_name: 'Name',
	mail_signatures_templates_delete_confirm: 'Signatur wirklich löschen?',
	mail_signatures_templates_empty_caption: 'Lege mit dem Button oben eine neue an.',
	mail_signatures_templates_empty_title: 'Keine globalen Signaturen vorhanden',
	mail_signatures_templates_new: 'Neue Signatur',
	mail_signatures_templates_title: 'Globale Signaturen',
	mail_signatures_user_fields_caption: 'Persönliche Werte, die Platzhalter in Signaturen füllen.',
	mail_signatures_user_fields_no_custom_placeholders:
		'Noch keine Custom-Platzhalter konfiguriert. Ein Administrator kann im Tab „Platzhalter" neue anlegen.',
	mail_signatures_user_fields_saved: 'Gespeichert',
	mail_signatures_user_fields_title: 'Persönliche Daten für Platzhalter',
	mail_signatures_user_signatures_caption: 'Signaturen einzelner Benutzer einsehen und verwalten.',
	mail_signatures_user_signatures_empty_title: 'Keine Signaturen für diesen Benutzer',
	mail_signatures_user_signatures_pick_user_hint: 'Wähle einen Benutzer, um dessen Signaturen zu verwalten.',
	mail_signatures_user_signatures_select_user: 'Benutzer auswählen',
	mail_spam_dialog_confirm_cancel_label: 'Nein',
	mail_spam_dialog_confirm_message: 'Möchten Sie diese E-Mail wirklich spammen?',
	mail_spam_dialog_confirm_ok_label: 'Ja',
	mail_spam_dialog_confirm_title: 'E-Mail als Spam markieren?',
	mail_subject: 'Betreff',
	mail_to: 'An',
};
